import React from 'react';
import AresNavBar from '../Layout/NavBar/NavBar';
import SideBar from '../Layout/SideBar/SideBar';

import './index.css';
import RegisterForm from './RegisterUserForm';

function RegisterUser () {
    return (
        <div>
            <AresNavBar />
            <SideBar />
            <div className="RegisterUser">
                <div className="bg-registerUser">
                    <div className="desktop-form">
                    </div>
                </div>
            </div>
            <RegisterForm/>
        </div>
    );
}

export default RegisterUser;
